import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { CircularProgress } from '@mui/material'
import { decryptAndRetrieveData } from './login/encript-decript'
import { signinmodal, clearSigninModalOnClose } from '../store/reducers'

function CompanyClaim() {
    const { company_id } = useParams()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [showRegisterModal, setShowRegisterModal] = useState(false)
    const [modalClosed, setModalClosed] = useState(false)

    // Get user and token
    const authData = decryptAndRetrieveData("isAuth", '123456789')
    const user = authData ? authData : null
    const token = localStorage.getItem('accessToken')

    console.log('CompanyClaim - user:', user)
    console.log('CompanyClaim - token:', token)
    console.log('CompanyClaim - company_id:', company_id)

    // Handle modal close (when user presses cross button)
    const handleModalClose = () => {
        console.log('Registration modal closed by user')
        setShowRegisterModal(false)
        setModalClosed(true)
        
        // Store the claim link in localStorage for later
        localStorage.setItem('pendingClaimLink', `/company/claim/${company_id}`)
        
        // Clear session storage
        sessionStorage.removeItem('pendingCompanyClaim')
        
        // Dispatch action to clear modal state in Redux
        dispatch(clearSigninModalOnClose())
        
        // Redirect to home page
        setTimeout(() => {
            navigate('/')
        }, 300)
    }

    useEffect(() => {
        // Store the company_id in sessionStorage for claim after registration
        if (company_id) {
            sessionStorage.setItem('pendingCompanyClaim', JSON.stringify({
                company_id: company_id,
                timestamp: Date.now()
            }))
        }

        // If user is logged in, call the API directly
        if (user && token) {
            handleClaimCompany()
        } else {
            // If not logged in, show registration modal
            setLoading(false)
            setShowRegisterModal(true)
            toast.info('Please Register to claim your company')
            // Pass the handleModalClose callback to the modal
            dispatch(signinmodal({ 
                isOpen: true, 
                isRegisterMode: true,
                onClose: handleModalClose 
            }))
        }
    }, [company_id])

    const handleClaimCompany = async () => {
        try {
            setLoading(true)
            setError(null)

            const apiUrl = `${process.env.REACT_APP_API_URL}/company/claim`
            
            if (!process.env.REACT_APP_API_URL) {
                throw new Error('REACT_APP_API_BASE_URL is not configured in .env file')
            }

            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    company_id: company_id
                })
            })

            console.log('Response status:', response.status)
            console.log('Response headers:', response.headers)
            console.log(response);
            
            let data
            const contentType = response.headers.get("content-type")
            
            if (contentType && contentType.includes("application/json")) {
                data = await response.json()
            } else {
                const text = await response.text()
                console.log('Response text (non-JSON):', text)
                throw new Error('Backend returned non-JSON response. Check API endpoint and CORS settings')
            }
            
            console.log('Response data:', data)

            if (!response.ok) {
                const errorMsg = data?.message || data?.error ||data || 'Failed to claim company'
                throw new Error(errorMsg)
            }
            
            // Clear the pending claim from both storages
            sessionStorage.removeItem('pendingCompanyClaim')
            localStorage.removeItem('pendingClaimLink')
            
            toast.success('Company claimed successfully!')
            setLoading(false)
            
            // Redirect to dashboard or my-company
            setTimeout(() => {
                navigate('/my-company')
            }, 1500)

        } catch (err) {
            console.error('Error claiming company:', err)
            setError(err.message)
            toast.error(err.message || 'Error claiming company')
            setLoading(false)
            
            setTimeout(() => {
                navigate('/')
            }, 2000)
        }
    }

    // Effect to handle claim after user registers and logs in
    useEffect(() => {
        const pendingClaimData = sessionStorage.getItem('pendingCompanyClaim')
        
        // Check if user just logged in with a pending claim
        if (user && token && pendingClaimData && !loading && showRegisterModal && !modalClosed) {
            try {
                const claimData = JSON.parse(pendingClaimData)
                console.log('Processing pending claim:', claimData)
                
                // Clear the register modal flag and proceed with claim
                setShowRegisterModal(false)
                handleClaimCompany()
            } catch (err) {
                console.error('Error parsing pending claim data:', err)
                sessionStorage.removeItem('pendingCompanyClaim')
            }
        }
    }, [user, token])

    return (
        <div style={{
            maxHeight: '83vh',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '20px'
        }}>
            {loading ? (
                <>
                    <CircularProgress style={{ color: "#4A5E00" }} />
                    <p>Processing your company claim...</p>
                </>
            ) : error ? (
                <>
                    <p style={{ color: 'red', fontSize: '16px', textAlign: 'center', maxWidth: '500px' }}>
                        Error: {error}
                    </p>
                    <button 
                        onClick={() => navigate('/')}
                        style={{
                            padding: '10px 20px',
                            backgroundColor: '#4A5E00',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer'
                        }}
                    >
                        Go to Home
                    </button>
                </>
            ) : modalClosed ? (
                <>
                    <p>Redirecting to Home...</p>
                    <CircularProgress style={{ color: "#4A5E00" }} />
                </>
            ) : showRegisterModal ? (
                <>
                    <p>Opening Registration Page...</p>
                    <p style={{ fontSize: '14px', color: '#666' }}>
                        Press the X button to go back home, or complete registration to claim your company
                    </p>
                    <CircularProgress style={{ color: "#4A5E00" }} />
                </>
            ) : (
                <p>Redirecting...</p>
            )}
        </div>
    )
}

export default CompanyClaim